export enum ApplicationPrivateRoutesEnum {
   MAIN_PAGE = 'main-page',
}

export enum MainPageChildRoutesEnum {
   FEATURE_MANAGE_PROJECTS = 'manage-projects',
   FEATURE_SEARCH_PROJECTS = 'search-projects',
   FEATURE_CREATE_PROJECT = 'create-project',
   FEATURE_MODIFY_PROJECT = 'modify-project/:id/:status',
   FEATURE_PROJECT_DETAILS = 'project-details/:id/:status',
   FEATURE_CHANGE_PASSWORD = 'change-password',
   FEATURE_EDIT_ACCOUNT = 'edit-account',
   FEATURE_MANAGE_DRAFT = 'manage-drafts',
}

export enum ApplicationPublicRoutesEnum {
   REGISTER = 'register',
   RESET_PASSWORD = 'reset-password',
   ACCESS_DENIED = 'access-denied',
   ACCOUNT_ACTIVATED_CONFIRMATION = 'activated-confirmation',
   REQUEST_CHANGE_PASSWORD = 'request-change-password',
}
